var $9a6cbac08487e661$exports = {};
$9a6cbac08487e661$exports = {
  "ascending": "stigende",
  "ascendingSort": function ascendingSort(args) {
    return "sorteret efter kolonne ".concat(args.columnName, " i stigende r\xE6kkef\xF8lge");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixels");
  },
  "descending": "faldende",
  "descendingSort": function descendingSort(args) {
    return "sorteret efter kolonne ".concat(args.columnName, " i faldende r\xE6kkef\xF8lge");
  },
  "resizerDescription": "Tryk p\xE5 Enter for at \xE6ndre st\xF8rrelse",
  "select": "V\xE6lg",
  "selectAll": "V\xE6lg alle",
  "sortable": "sorterbar kolonne"
};
export { $9a6cbac08487e661$exports as default };